export const itemHeaderReplyAll = "YRa";
export default {itemHeaderReplyAll};